/**
 * Created by kocsmarb on 2018.06.26..
 */

export default AjaxRequest;

const $ = jQuery;

function AjaxRequest( customArgs )
{
    var defaultArgs = {
        type: "POST",
        dataType: "json",
        async: true,
        cache: false,
        timeout: 0,
        success: function(response) {
            console.log( response );
        },
        error: function (responseData, textStatus, errorThrown) {
            console.error('Sikertelen adat kommunikáció.');
        },
        complete: function(){
        }
    };

    $("#dataSheetLoader").addClass("active");

    customArgs = $.extend(defaultArgs, customArgs);

    $.ajax(customArgs)
        .done(function () {
            $("#dataSheetLoader").removeClass("active");
        });
}